import { useEffect, useMemo, useState } from "react";
import React from "react";
import { Form } from "react-bootstrap";

import DstButton from "../../../../components/DstButton/DstButton";
import MultiSelectDropdown from "../../../../components/MultiSelectDropdown/MultiSelectDropdown";
import Popup from "../../../../components/Popup/Popup";
import translate from "../../../../services/Translate";
import { EvaluationPartnersModalProps, Partner } from "./PartnersModal.d";
import { fetchPartners, updateEvaluationPartners } from "./PartnersModal.function";

const PartnersModal = ({
  show,
  closeModal,
  evaluationId,
  evaluationPartners,
  language,
  onSuccess,
}: EvaluationPartnersModalProps) => {
  const [partners, setPartners] = useState<Array<Partner>>([]);
  const [partnersLoading, setPartnersLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedPartnerIds, setSelectedPartnerIds] = useState<Array<number>>([]);

  useEffect(() => {
    if (!show) return;
    fetchPartners(setPartners, setPartnersLoading, language);
    setSelectedPartnerIds(evaluationPartners.map((partner) => partner.id));
  }, [show, evaluationPartners, language]);

  const defaultSelectedItems = useMemo(
    () =>
      partners.filter((partner) => evaluationPartners.some((evaluationPartner) => evaluationPartner.id === partner.id)),
    [partners, evaluationPartners]
  );

  const _handleSubmit = () => {
    updateEvaluationPartners(
      evaluationId,
      selectedPartnerIds,
      setLoading,
      () => {
        onSuccess();
        closeModal();
      },
      language
    );
  };

  return (
    <Popup
      show={show}
      onClose={() => closeModal()}
      modalTitle={translate(language, "PAGES.EVALUATION.PARTNERS_MODAL.TITLE")}
      footerContent={
        <React.Fragment>
          <DstButton variant="secondary" value={translate(language, "GLOBAL.CANCEL")} clickFunction={closeModal} />
          <DstButton
            loading={loading}
            disabled={loading || partnersLoading}
            value={translate(language, "GLOBAL.SAVE")}
            clickFunction={_handleSubmit}
          />
        </React.Fragment>
      }
    >
      <Form.Group>
        <Form.Label>{translate(language, "PAGES.EVALUATION.PARTNERS_MODAL.LABEL")}</Form.Label>
        <MultiSelectDropdown
          items={partners}
          language={language}
          label={
            selectedPartnerIds.length
              ? `${selectedPartnerIds.length} ${translate(language, "PAGES.EVALUATION.PARTNERS_MODAL.SELECTED")}`
              : translate(language, "PAGES.EVALUATION.PARTNERS_MODAL.PLACEHOLDER")
          }
          mock={partnersLoading}
          badgeItemProperty="name"
          displayItem={(partner: Partner) => <span>{partner.name}</span>}
          defaultSelectedItems={defaultSelectedItems}
          onConfirm={(selectedPartners) => setSelectedPartnerIds(selectedPartners.map((partner) => partner.id))}
          confirmOnClose
          borderToggle
          btnWidth="100%"
          toggleClass="w-100"
        />
      </Form.Group>
    </Popup>
  );
};

export default PartnersModal;
